<div id="content-page" class="content-page">
  <div class="container-fluid">
      
<div class="row">
  <div class="col-md-12">
    <div class="iq-card iq-card-block iq-card-stretch iq-card-height">
      <div class="iq-card-body">
        <div *ngIf="!isTeamAssignment" class="title">Member List Overview</div>
        <div *ngIf="isTeamAssignment && !isTeamMemView" class="title">Member Team Assignment ({{teamName}})</div>
        <div *ngIf="isTeamAssignment && isTeamMemView" class="title">Member Team Un-Assignment ({{teamName}})</div>
      </div>
        </div>
     </div>
  
</div>
<div *ngIf="!isTeamAssignment"  class="row mt-4 flex">
  <div class="col-auto">
    <select class="form-control select" [(ngModel)]="searchType" (change)="onSearchTypeChange()">
      <option value="Name">Name</option>
      <option value="Email">E-mail</option>
      <option value="Phone Number">Phone Number</option>
    </select>
  </div>

  <div class="search-col">
    <div class="iq-search-bar">
      <form action="#" class="searchbox">
        <input type="text" #nameInput class="text search-input searchInner" (keyup)="filterData($event,1)" [placeholder]="'Search Member By ' + searchType">
        <a class="search-link" href="javascript:void(0)">
          <i class="fa-solid fa-magnifying-glass" style="color:#000"></i>
        </a>
      </form>
    </div>
  </div>

  <div class="col-auto">
    <select class="form-control select" [(ngModel)]="selectFilterBy" (change)="filterData($event,2)">
      <option value="none">All Filters</option>
      <option value="byName">byName</option>
      <option value="bySignUpDate">bySignUpDate</option>
      <option value="pendingProfile">pendingProfile</option>
      <option value="onBoardingPending">onBoardingPending</option>
      <option value="questionaryPending">questionaryPending</option>
      <option value="labWorkPending">labWorkPending</option>
      <option value="callPending">callPending</option>
      <option value="completedProfile">completedProfile</option>
      <option value="onboardingCompleted">onboardingCompleted</option>
      <option value="questionaryCompleted">questionaryCompleted</option>
      <option value="labWorkCompleted">labWorkCompleted</option>
      <option value="callCompleted">callCompleted</option>
    </select>
  </div>

  <div class="col-auto">
    <select class="form-control select" [(ngModel)]="selectedTeamsFilter" (change)="filterData($event,3)">
      <option value="">All Teams</option>
      <option *ngFor="let item of teamsFilter" value="{{item.teamId}}">
        {{ item.teamName }}
      </option>
    </select>
  </div>

  <div class="col-auto">
    <select class="form-control select" [(ngModel)]="selectLevelBy" (change)="filterData($event,4)">
      <option value="0">All Levels</option>
      <option value="1">Level 1</option>
      <option value="2">Level 2</option>
      <option value="3">Level 3</option>
      <option value="4">Level 4</option>
      <option value="5">Level 5</option>
    </select>
  </div>

  <div class="col-auto">
    <button class="btn applyBtn" (click)="resetSearch()">Reset</button>
  </div>
</div>

<div *ngIf="!isLoading && memberDetails['totalCount'] === 0" class="row mt-5">
  <div class="col-12 empty-state-message">No members assigned yet.</div>
</div>

<div *ngIf="isLoading || memberDetails['totalCount'] > 0" class="row mt-5">
  <button *ngIf="isTeamAssignment && !isTeamMemView" class="btn applyBtn" mat-raised-button color="primary" (click)="assignTeam()">Assign Team</button>
  <button *ngIf="isTeamAssignment && isTeamMemView" class="btn applyBtn" mat-raised-button color="primary" (click)="unAssignTeam()">Un-Assign Team</button>

  <table mat-table [dataSource]="dataSource">

    <!-- Checkbox Column -->
    <ng-container matColumnDef="Select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="toggleSelectAll($event)"></mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox [(ngModel)]="element.isSelected" (change)="onMemberSelect(element.memberId, $event)"></mat-checkbox>
      </td>
    </ng-container>

    <!-- Position Column -->
    <ng-container matColumnDef="No">
      <th mat-header-cell *matHeaderCellDef> No</th>
      <td mat-cell *matCellDef="let element;let i = index;"> {{pageIndexVal+i+1}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="FirstName">
      <th mat-header-cell *matHeaderCellDef> Name </th>
      <td mat-cell *matCellDef="let element">{{element.firstName}} {{element.lastName}} </td>
    </ng-container>



    <!-- Symbol Column -->
    <ng-container matColumnDef="Email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element"> {{element.email}}</td>
    </ng-container>


    <ng-container matColumnDef="Mobile">
      <th mat-header-cell *matHeaderCellDef> Phone Number</th>
      <td mat-cell *matCellDef="let element"> +{{element.phoneNumber}}</td>
    </ng-container>

    <ng-container matColumnDef="City">
      <th mat-header-cell *matHeaderCellDef> City </th>
      <td mat-cell *matCellDef="let element"> {{element.address.city}}</td>
    </ng-container>

    <ng-container matColumnDef="State">
      <th mat-header-cell *matHeaderCellDef> State </th>
      <td mat-cell *matCellDef="let element"> {{element.address.state}}</td>
    </ng-container>



    <ng-container matColumnDef="Team">
      <th mat-header-cell *matHeaderCellDef> Team </th>
      <td mat-cell *matCellDef="let element"> {{element.teamName}}</td>
    </ng-container>

    <ng-container matColumnDef="CreatedDateTime">
      <th mat-header-cell *matHeaderCellDef> Sign Up Date </th>
      <td mat-cell *matCellDef="let element"> {{element.createdDateTime | date:"MMMM d, y 'at' h:mm a"}}</td>
    </ng-container>

      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row" class="flex" style="padding: 10px;">
         
          <a [routerLink]="['/member-details']" [queryParams]="{ id:row.memberId,islist:1}" [state]="{stateObj:filter}" class="memberDashboard1" mat-button>View Details</a>
          <a [routerLink]="['/member-dashboard']" [queryParams]="{ memberId:row.memberId}" [state]="{stateObj:filter}" class="memberDashboard ml-2" mat-button>Member Dashboard</a>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      
    </table>

  <mat-paginator #paginator
                 (page)="pageChangeEvent($event)"
                 [length]="this.memberDetails['totalCount']"
                 [pageSize]="pageSize"
                 [pageIndex]="0"
                 [length]="this.memberDetails['totalCount']"
                 showFirstLastButton>
  </mat-paginator>

  <!-- <div class="col-md-12 col-lg-6">
    <div><span class="levelTitle">Level of Care:</span><span class="levelTitle2"> L1</span></div>
  </div>  -->
</div>
  <!-- <div class="row flex mt-4 align-items-start">
    
    <app-member-card class="col-4" *ngFor='let member of this.memberLists[0];let i=index' [memberdata]="member[i]" [screentype] = "1"></app-member-card>
      </div>

      <div class="row mt-5">
        <div class="col-md-12 col-lg-6">
          <div><span class="levelTitle">Level of Care:</span><span class="levelTitle2"> L3</span></div>
        </div>
      </div>
      <div class="row flex mt-4 align-items-start">
        
        <app-member-card class="col-4" *ngFor='let member of memberLists[1];' [memberdata]="member" [screentype] = "1"></app-member-card>
      </div>

        <div class="row mt-5">
            <div class="col-md-12 col-lg-6">
              <div><span class="levelTitle">Level of Care:</span><span class="levelTitle2"> L3</span></div>
            </div>
          </div>
          <div class="row flex mt-4 align-items-start">
            
            <app-member-card class="col-4" *ngFor='let member of memberLists[2];' [memberdata]="member" [screentype] = "1"></app-member-card>
          </div>


          <div class="row mt-5">
            <div class="col-md-12 col-lg-6">
              <div><span class="levelTitle">Level of Care:</span><span class="levelTitle2"> L4</span></div>
            </div>
          </div>
          <div class="row flex mt-4 align-items-start">
            
            <app-member-card class="col-4" *ngFor='let member of memberLists[3];' [memberdata]="member" [screentype] = "1"></app-member-card>
          </div>

          <div class="row mt-5">
            <div class="col-md-12 col-lg-6">
              <div><span class="levelTitle">Level of Care:</span><span class="levelTitle2"> L5</span></div>
            </div>
          </div>
          <div class="row flex mt-4 align-items-start">
            
            <app-member-card class="col-4" *ngFor='let member of memberLists[4];' [memberdata]="member" [screentype] = "1"></app-member-card>
          </div>

        </div>

  
  </div> -->
